﻿import { ready } from "./ready";
import { onEvent } from "./_dom";

const pinSideCookie = "v3-sidebar";

/* Button action
             | Closed |  Open  | Pinned
-------------+--------+--------+---------
Not pinnable |  Open  |  Close |  Close
-------------+--------+--------+---------
Pinnable     |  Open  |  Pin   |  Close
-------------+--------+--------+---------
*/

const kStateClosed = "closed";
const kStateOpen = "open";
const kStatePinned = "pinned";

/* from media query */
let sidebarPinnable = false;
/* actual state */
let sidebarState;

let button;
let showText, hideText, pinText;

const rootElement = document.documentElement;

/**
 * @param {"closed"|"open"|"pinned"} state
 */
function toggleSidebarShow(state) {
	if (state === sidebarState)
		return;

	sidebarState = state;

	if (state === kStateOpen) {
		document.addEventListener("click", hideOnClickOutside);
	} else {
		document.removeEventListener("click", hideOnClickOutside);
	}

	rootElement.classList.toggle("v3-sidebar--show", state !== kStateClosed);
	rootElement.classList.toggle("v3-sidebar--pinned", state === kStatePinned);
	if (button) {
		if (!showText && !hideText && !pinText) {
			({ show: showText, hide: hideText, pin: pinText } = JSON.parse(button.dataset.jsSidebar));
		}
		const buttonText = state === kStateClosed ? showText : state === kStateOpen && sidebarPinnable ? pinText : hideText;
		button.querySelector(".ui-icontext").replaceChildren(buttonText);
	}
}

function hideOnClickOutside(event) {
	if (!event.target.closest(".v3-sidebar")) {
		if (sidebarState === kStateOpen)
			toggleSidebarShow(kStateClosed);
		document.removeEventListener("click", hideOnClickOutside);
	}
}

function onButtonClick(event) {
	event.preventDefault();
	let newSidebarState = kStateClosed;
	switch (sidebarState) {
		case kStateClosed:
			newSidebarState = kStateOpen;
			document.addEventListener("click", hideOnClickOutside);
			break;
		case kStateOpen:
			if (sidebarPinnable) {
				localStorage.setItem(pinSideCookie, "1");
				newSidebarState = kStatePinned;
			}
			break;
		case kStatePinned:
			localStorage.setItem(pinSideCookie, "0");
			break;
	}
	toggleSidebarShow(newSidebarState);
}

function onChangeMediaQuery({ matches }) {
	sidebarPinnable = !matches;
	rootElement.classList.toggle("v3-sidebar--pinnable", sidebarPinnable);
	// toggle pinned and open
	const calculatedSidebarState = !sidebarPinnable && sidebarState === kStatePinned ? kStateOpen : sidebarState;
	toggleSidebarShow(calculatedSidebarState);
}

// we run this as soon as possible. at the moment script runs it is not known
// whether there is no sidebar at all, or sidebar is not yet rendered.
// hence, server flags sidebar-enabled pages with .js-has-sidebar
function init(context, selector = "[data-js-sidebar]", trigger = ".js-has-sidebar") {
	if (!document.documentElement.matches(trigger))
		return;

	onEvent(context, selector, "click", onButtonClick);


	// matches sidebar.scss
	const mq = window.matchMedia("only screen and (max-width: 1279px)");
	mq.addEventListener("change", onChangeMediaQuery);

	sidebarPinnable = !mq.matches;
	rootElement.classList.toggle("v3-sidebar--pinnable", sidebarPinnable);
	const pinnableSidebarShow = !!+(localStorage.getItem(pinSideCookie) ?? "1");

	/* initially sidebar is open only if pinnable and pinned */
	const calculatedSidebarState = sidebarPinnable && pinnableSidebarShow ? kStatePinned : kStateClosed;

	button = context.querySelector(selector);
	toggleSidebarShow(calculatedSidebarState);

	if (!button) {
		// repeat attempt when ready
		ready(() => {
			button = context.querySelector(selector);
			if (button)
				toggleSidebarShow(calculatedSidebarState);
		});
	}
}

export { init };